import React, { useMemo } from 'react';
import { CoachReviewTypesEnum, Reviews } from 'types/generated/client';
import CourtFlat from 'svg/CourtFlat';
import VideoCamera from 'svg/VideoCamera';
import { ReviewType } from 'screens/CoachDetails/types';
import { calculateCategoryRating } from 'screens/CoachDetails/utils';
import CustomStarRating from 'components/CustomStarRating';

const OverallStats: React.FC<{ reviews: ReviewType[] }> = ({ reviews }) => {
  const generalRating = useMemo(
    () =>
      reviews.length > 0
        ? (reviews.reduce((acc, review) => acc + review.rating, 0) / reviews.length).toFixed(1)
        : '0.0',
    [reviews],
  );

  const courtOverallRating = useMemo(
    () => calculateCategoryRating(CoachReviewTypesEnum.Court, reviews as Reviews[]),
    [reviews],
  );

  const remoteOverallRating = useMemo(
    () => calculateCategoryRating(CoachReviewTypesEnum.Remote, reviews as Reviews[]),
    [reviews],
  );

  const stats = [
    {
      icon: <CourtFlat className="h-6 w-4" />,
      label: 'On-court',
      rating: courtOverallRating,
    },
    {
      icon: <VideoCamera className="h-5 w-5" />,
      label: 'Remote',
      rating: remoteOverallRating,
    },
  ];

  return (
    <div className="sticky top-0 flex w-full flex-col items-center md:max-w-[25rem] ">
      <h2 className="typography-informative-display-mega-secondary-desktop">{generalRating}</h2>
      <CustomStarRating
        initialRating={parseFloat(generalRating)}
        starCount={5}
        readOnly
        fillColorClassName="text-color-text-lightmode-primary"
        unfillColorClassName="text-color-bg-lightmode-secondary"
      />
      <span className="typography-product-element-label mt-3 text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary">
        General Rating
      </span>
      <div className="mt-8 flex w-full flex-col gap-2">
        <hr className="my-2" />
        {stats.map((stat, index) => (
          <React.Fragment key={index}>
            <div className="typography-product-card-title-desktop flex justify-between">
              <div className="flex items-center gap-3">
                <div className="w-5">{stat.icon}</div>
                <span>{stat.label}</span>
              </div>
              <span className="text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                {stat.rating}
              </span>
            </div>
            {index < stats.length - 1 && <hr className="my-2" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default OverallStats;
